import styled from "styled-components";
import Button from "../../../bootstrap/Button";
import NavItem from "../../../bootstrap/NavItem";
import Ul from "../../../bootstrap/Ul";

/* Main checkout card */
export const MpesaCheckout = styled.div`
  width: 100%;
  max-width: 620px;
  margin: 0 auto;
  padding: 18px;
  box-sizing: border-box;
  border: 1px solid #e7ebef;
  border-radius: 10px;
  background: #fff;
  color: #263746;
  font-family: inherit;
  box-shadow: 0 3px 14px rgba(16, 24, 40, 0.045);

  @media (max-width: 576px) {
    padding: 13px;
    border-radius: 8px;
  }
`;

/* Header */
export const MpesaHeading = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 15px;
  padding-bottom: 14px;
  border-bottom: 1px solid #edf0f3;

  h3 {
    margin: 2px 0 3px;
    color: #172b3a;
    font-size: 18px;
    font-weight: 700;
    line-height: 1.25;
  }

  p {
    margin: 0;
    color: #7b8794;
    font-size: 11px;
    line-height: 1.4;
  }
`;

export const MpesaHeaderIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  border: 1px solid #dcece2;
  border-radius: 8px;
  background: #f4faf6;
  color: #16834a;
  font-size: 15px;
`;

export const MpesaEyebrow = styled.span`
  display: block;
  color: #16834a;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 1px;
`;

/* Sections */
export const MpesaSection = styled.section`
  margin-top: 13px;
`;

export const MpesaSectionHeading = styled.div`
  display: flex;
  align-items: center;
  gap: 9px;
  margin-bottom: 9px;

  h4 {
    margin: 0 0 2px;
    color: #263746;
    font-size: 12px;
    font-weight: 750;
  }

  p {
    margin: 0;
    color: #84909d;
    font-size: 10px;
    line-height: 1.35;
  }
`;

export const MpesaStep = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 25px;
  height: 25px;
  flex-shrink: 0;
  border-radius: 7px;
  background: #f0f7f2;
  color: #16834a;
  font-size: 10px;
  font-weight: 800;
`;

/* Payment method list */
export const PaymentUl = styled(Ul)`
  display: flex;
  width: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const SinglePayment = styled(NavItem)`
  position: relative;
  display: flex;
  width: 100%;
  margin: 0;
  padding: 0;
`;

export const PaymentInput = styled.input`
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;

  &:focus-visible + label {
    outline: 2px solid #2563eb;
    outline-offset: 2px;
  }

  &:checked + label {
    border-color: #16834a;
    background: #f6fbf7;
  }

  &:checked + label span:last-child {
    background: #16834a;
    color: #fff;
  }

  &:disabled + label {
    opacity: 0.55;
    cursor: not-allowed;
  }
`;

export const MpesaOption = styled.label`
  display: flex;
  align-items: center;
  gap: 11px;
  width: 100%;
  min-height: 58px;
  padding: 8px 11px;
  box-sizing: border-box;
  border: 1px solid #e1e7ee;
  border-radius: 8px;
  background: #fff;
  cursor: pointer;
  transition: border-color 0.18s ease, background 0.18s ease;

  &:hover {
    border-color: #16834a;
    background: #fbfefc;
  }

  @media (max-width: 420px) {
    gap: 8px;
    padding: 8px;
  }
`;

export const MpesaLogo = styled.img`
  display: block;
  width: 53px;
  height: 38px;
  flex-shrink: 0;
  padding: 3px;
  box-sizing: border-box;
  object-fit: contain;
  border: 1px solid #edf0f3;
  border-radius: 5px;
  background: #fff;
`;

export const MpesaOptionDetails = styled.span`
  display: flex;
  flex: 1;
  min-width: 0;
  flex-direction: column;
  gap: 2px;

  strong {
    color: #172b3a;
    font-size: 12px;
    font-weight: 750;
  }

  small {
    color: #7b8794;
    font-size: 10px;
  }
`;

export const MpesaSelected = styled.span`
  flex-shrink: 0;
  padding: 4px 8px;
  border-radius: 20px;
  background: #f0f2f5;
  color: #667085;
  font-size: 9px;
  font-weight: 700;
`;

/* Three compact payment steps */
export const MpesaInstructions = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  padding: 10px;
  border: 1px solid #edf0f3;
  border-radius: 8px;
  background: #f9fafb;

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    gap: 9px;
  }
`;

export const MpesaInstructionItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 7px;
  min-width: 0;

  > span {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 21px;
    height: 21px;
    flex-shrink: 0;
    border: 1px solid #dcece2;
    border-radius: 50%;
    background: #f1f8f3;
    color: #16834a;
    font-size: 9px;
    font-weight: 800;
  }

  > div {
    display: flex;
    min-width: 0;
    flex-direction: column;
    gap: 3px;
  }

  strong {
    color: #344054;
    font-size: 10px;
    font-weight: 700;
    line-height: 1.3;
  }

  small {
    color: #84909d;
    font-size: 9px;
    line-height: 1.4;
  }
`;

/* Phone number field */
export const MpesaPhoneField = styled.div`
  margin: 0;

  label {
    display: block;
    margin-bottom: 5px;
    color: #344054;
    font-size: 10px;
    font-weight: 700;
  }

  label span {
    color: #dc2626;
  }

  .phone-input-wrapper {
    display: flex;
    align-items: center;
    gap: 9px;
    min-height: 40px;
    padding: 0 10px;
    border: 1px solid #d9e0e7;
    border-radius: 7px;
    background: #fff;
    transition: border-color 0.18s ease, box-shadow 0.18s ease;
  }

  .phone-input-wrapper:focus-within {
    border-color: #16834a;
    box-shadow: 0 0 0 2px rgba(22, 131, 74, 0.08);
  }

  .phone-prefix {
    padding-right: 8px;
    border-right: 1px solid #e4e7ec;
    color: #667085;
    font-size: 10px;
    font-weight: 800;
  }

  input {
    display: block;
    width: 100%;
    min-width: 0;
    min-height: 36px;
    padding: 6px 0;
    border: none;
    outline: none;
    background: transparent;
    color: #263746;
    font-size: 12px;
    font-weight: 600;
  }

  input::placeholder {
    color: #b0b8c2;
    font-weight: 400;
  }

  input:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

  .phone-input-wrapper i {
    color: #98a2b3;
    font-size: 16px;
  }

  > small {
    display: block;
    margin-top: 5px;
    color: #84909d;
    font-size: 9px;
    line-height: 1.4;
  }
`;

/* Total payable */
export const MpesaTotal = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-top: 13px;
  padding: 11px 13px;
  border: 1px solid #dcece2;
  border-radius: 8px;
  background: #f6faf7;

  > div {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  span {
    color: #344054;
    font-size: 11px;
    font-weight: 700;
  }

  small {
    color: #84909d;
    font-size: 9px;
  }

  strong {
    color: #16834a;
    font-size: 17px;
    font-weight: 800;
    white-space: nowrap;
  }

  @media (max-width: 420px) {
    padding: 10px;

    strong {
      font-size: 15px;
    }
  }
`;

/* Security note */
export const MpesaSecurityNote = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin-top: 11px;
  color: #84909d;
  font-size: 9px;
  text-align: center;

  i {
    color: #16834a;
    font-size: 11px;
  }
`;

/* Action buttons */
export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 9px;
  width: 100%;
  margin-top: 15px;

  button {
    margin: 0;
  }

  @media (max-width: 480px) {
    flex-direction: column-reverse;
    align-items: stretch;

    button {
      width: 100%;
    }
  }
`;

export const CancelButton = styled(Button)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  min-height: 38px;
  padding: 8px 15px;
  border: 1px solid #d5dce5;
  border-radius: 7px;
  background: #fff;
  color: #344054;
  font-size: 11px;
  font-weight: 650;
  text-transform: none;
  transition: background 0.18s ease, border-color 0.18s ease;

  &:hover:not(:disabled) {
    background: #f5f7fa;
    border-color: #98a2b3;
  }

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }
`;

export const PaymentButton = styled(Button)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 38px;
  padding: 8px 17px;
  border: none;
  border-radius: 7px;
  background: ${({ btnbgcolor }) => btnbgcolor || "#16834a"};
  color: ${({ btntextcolor }) => btntextcolor || "#fff"};
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.1px;
  text-transform: none;
  cursor: pointer;
  transition: background 0.18s ease, opacity 0.18s ease;
  box-shadow: 0 2px 5px rgba(22, 131, 74, 0.13);

  &:hover:not(:disabled) {
    background: ${({ btnbghvcolor }) => btnbghvcolor || "#116b3c"};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    box-shadow: none;
  }
`;

/* Cancel booking link */
export const MpesaFooterActions = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 8px;

  button {
    padding: 3px 7px;
    border: none;
    background: transparent;
    color: #84909d;
    font-size: 10px;
    cursor: pointer;
    text-decoration: underline;

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
`;

/* Status messages */
export const MpesaStatusText = styled.p`
  margin: 7px 0 0;
  color: #667085;
  font-size: 10px;
  line-height: 1.4;
`;

export const MpesaUnavailable = styled.p`
  margin: 9px 0 0;
  padding: 8px;
  border-radius: 6px;
  background: #fff4f2;
  color: #c0392b;
  font-size: 10px;
  line-height: 1.4;
  text-align: center;
`;

/* Backwards-compatible exports */
export const PaymentAndButton = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
  width: 100%;
  margin-top: 15px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const Label = styled.label`
  cursor: pointer;
`;

export const PaymentMethod = styled.div`
  display: flex;
  align-items: flex-start;
  width: 100%;
  margin-top: 12px;
`;